import React from "react";
import {
	Divider,
	List,
	ListItem,
	ListItemText,
	ListSubheader,
	makeStyles
} from "@material-ui/core";

import { makeMessages } from "../../utils/makeMessages";
import { ContentSidePanel } from "./ContentSidePanel";



export const ContentSidePanelRestauracia = () => {
	const classes = useStyles();
	const msgs = useMessages();
	
	return (
		<ContentSidePanel>
			<List component="dl" className={classes.dl}>
				<ListSubheader component="dt" className={classes.dt}>{msgs.openingHours}</ListSubheader>
				<ListItem component="dd" className={classes.dd}><ListItemText>10:00 - 21:00</ListItemText></ListItem>
				
				<Divider className={classes.divider} />
				
				<ListSubheader component="dt" className={classes.dt}>{msgs.breakfast}</ListSubheader>
				<ListItem component="dd" className={classes.dd}><ListItemText>07:30 - 09:30</ListItemText></ListItem>
				
				<ListSubheader component="dt" className={classes.dt}>{msgs.lunch}</ListSubheader>
				<ListItem component="dd" className={classes.dd}><ListItemText>11:30 - 14:00</ListItemText></ListItem>
				
				<ListSubheader component="dt" className={classes.dt}>{msgs.dinner}</ListSubheader>
				<ListItem component="dd" className={classes.dd}><ListItemText>18:00 - 20:00</ListItemText></ListItem>
			</List>
		</ContentSidePanel>
	);
};

const useStyles = makeStyles(theme => ({
	dl: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	dt: {
		width: '50%',
	},
	dd: {
		width: '50%',
		margin: 0,
	},
	divider: {
		width: '100%',
	},
}));

const useMessages = makeMessages({
	openingHours: {
		sk: 'Otváracie hodiny',
		en: 'Opening hours',
	},
	breakfast: {
		sk: 'Raňajky',
		en: 'Breakfast',
	},
	lunch: {
		sk: 'Obed',
		en: 'Lunch',
	},
	dinner: {
		sk: 'Večera',
		en: 'Dinner',
	}
});
